import React, { useState } from "react";
import { Switch, Table, Modal, Space, Avatar, Image } from "antd";
import { ToastContainer, toast } from 'react-toastify';
import IntlMessages from "../../../../util/IntlMessages";
import { PageSize } from "src/apis/helpers/configs/page-sizes";
import { useGetStandards } from "src/hooks/services/standards/useGetStandards";
import { useDeleteStandards } from "src/hooks/services/standards/useDeleteStandards";
const confirm = Modal.confirm;
const { Column } = Table;
const List = (props) => {
  const [page, setPage] = useState(1);
  const { data: StandardsData, isLoading } = useGetStandards();
  const { mutate: onDeleteStandards } = useDeleteStandards();

  const changePage = (page) => {
    setPage(page);
  };

  const editStandards = (data) => {
    props.changeTabEvent("2", data); // raftan be tab edit
  };

  const showDeleteConfirm = (data) => {
    confirm({
      title: "آیا از حذف این استاندارد اطمینان دارید ؟",
      okText: "بله",
      okType: "danger",
      cancelText: "خیر",
      onOk() {
        onDeleteStandards(data.standardId, {
          onSuccess: (data) => {
            toast.success(
              <IntlMessages id="notification.successMessage" />
            );
          },
          onError: (err:any) => {
            toast.error(
              err.message
            );
          },
        });
      },
      onCancel() { },
    });
  };

  return (
    <>
      <Table
        className="gx-table-responsive"
        dataSource={StandardsData}
        rowKey="StandardsId"
      >
        <Column
          title="عکس"
          dataIndex="standardImage"
          key="standardImage"
          render={(text, record: any) => (
            <Avatar shape="square" size={80} src={<Image src={record.standardImage} />} />
          )}
        />
        <Column title="عنوان" dataIndex="standardTitle" key="standardTitle" />
        <Column
          title="ویرایش"
          key="action"
          render={(text, record) => (
            <Space size="middle">
              <a onClick={() => editStandards(record)}>ویرایش</a>
            </Space>
          )}
        />
        <Column
          title="حذف"
          key="action"
          render={(text, record) => (
            <Space size="middle">
              <a onClick={() => showDeleteConfirm(record)}>حذف</a>
            </Space>
          )}
        />
      </Table>
       {/* <NotificationContainer /> */}
    </>
  );
};

export default List;
